import React from 'react';
import { Route, BrowserRouter } from "react-router-dom";
import UserRestorePasswordSuccess from './UserRestorePasswordSuccess';
import RemoveAuthModule from './RemoveAuthModule';

function UserController({ user }) {
  return (
    <BrowserRouter>
      <Route path={`/ru/recover/:recoverId`}
        render={({ match }) => <UserRestorePasswordSuccess user={user} recoverId={match.params.recoverId} />}>
      </Route>
      <Route path={`/ru/maps/hcvf-russia`} component={RemoveAuthModule}>

      </Route>
    </BrowserRouter>
  )
}

export default UserController;